export default {
  pegasusUrl: process.env.REACT_APP_PEGASUS_URL,
  recognitionSigninUrl: process.env.REACT_APP_RECOGNITION_SIGN_IN_URL,
  recognitionAccountManagementUrl: process.env.REACT_APP_RECOGNITION_ACCOUNT_MANAGEMENT_URL,
  recognitionPasswordManagementUrl: process.env.REACT_APP_RECOGNITION_PASSWORD_MANAGEMENT_URL,
  recognitionReauthenticateUrl: process.env.REACT_APP_RECOGNITION_REAUTHENTICATE_URL,
  cachingNamespace: 'descomplica-io-study-plan-ui',
  recognitionBaseUrl: process.env.REACT_APP_RECOGNITION_BASE_URL,
  launchDarklyClientId: process.env.REACT_APP_LAUNCHDARKLY_CLIENT_ID,
  kaltura_cdn: process.env.REACT_APP_KALTURA_CDN,
  linkedinOrganizationId: process.env.REACT_APP_LINKEDIN_ORGANIZATION_ID,
  cloudfrontUrl: process.env.REACT_APP_CLOUDFRONT_URL,
};
